"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const next_components_sections_articles_1 = __importDefault(require("@motorata/next.components.sections.articles"));
const ArticlesContent_1 = require("./ArticlesContent");
const ArticlesMainView = ({ label = "Blog", title = "Najnowsze informacje ze świata motoryzacji", contentTitle, contentLabel, articles = [], currentPage, totalPages, onChangePage, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(base_ui_components_atoms_typography_1.Title, { type: "primary", label: label }, title),
        react_1.default.createElement(next_components_sections_articles_1.default, { mt: "2rem", data: articles.slice(0, 4), showTitle: false, showButton: false }),
        react_1.default.createElement(ArticlesContent_1.ArticlesContent, { articles: articles.slice(4, 13), title: contentTitle, label: contentLabel, currentPage: currentPage, totalPages: totalPages, onChangePage: onChangePage })));
};
exports.default = ArticlesMainView;
//# sourceMappingURL=ArticlesMainView.js.map